'use strict';

const processInclude = require('base/util');

document.addEventListener('DOMContentLoaded',function () {
    processInclude(require('./stylitics/stylitics'));
});
